

import React, { Suspense } from "react";

const Line = React.lazy(() =>
  import("@ant-design/plots").then(module => ({ default: module.Line }))
);

const LineChart = ({ config }) => {
  return (
    <Suspense fallback={<div>Loading chart...</div>}>
      <Line {...config} />
    </Suspense>
  );
};

export default LineChart;
